import React from 'react';
import { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { NavLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';

import doctorDemo from '../../assets/images/doctor-demo.png'

import { useStyles } from './HomeContentStyles.js'

const DepartmentsList = ({ listDepartments }) => {

    const classes = useStyles();

    const [departments, setDepartments] = useState(null);

    useEffect(() => {
        (async () => {
            const departments = await listDepartments();
            setDepartments(departments);
        })();
    }, [listDepartments]);

    if (!departments || departments.length === 0) return <p>Can not find any department, sorry</p>;
    return (
        <Grid container mt={2}>
            {departments.map((department) => {
                return (
                    <Grid item key={department.id} xs={12} sm={12} md={6} className={classes.homeContentList}>
                        <Link to={'servizi/' + department.slug} component={NavLink} className={classes.homeDepartmentLink} title={department.name}> <strong>- {department.name}</strong></Link>
                    </Grid>
                );
            })}
        </Grid>
    );
};

function HomeContent({ listDepartments }) {

    const classes = useStyles();

    return (
        <>
            <Box className={classes.homeContentWrapper} mt={30}>
                <Box className={classes.homepageOverlay}>
                    <Container maxWidth="xl">
                        <Grid container>
                            <Grid item sm={12} md={6} className={classes.homeContentCEOCard}>
                                <Paper elevation={2} className={classes.homeContentCEOPaper}>
                                    <Typography className={classes.homeContentCEOSubTitle}>
                                        UNO STILE DI VITA SANO CONTRIBUISCE A
                                    </Typography>
                                    <Typography variant="h4" className={classes.homeContentCEOTitle}>
                                        UNA BUONA SALUTE
                                    </Typography>
                                    <Grid container>
                                        <Grid item md={6}>
                                            <img src={doctorDemo} className={classes.homeContentCEOImage} alt="CEO" />
                                        </Grid>
                                        <Grid item md={6} sx={{ padding: '10px', marginBottom: '15px' }}>
                                            <Typography mt={5} mb={5} className={classes.homeContentText}>
                                                <strong>Richiedi un appuntamento</strong> e <strong>prenota una visita</strong> on line da uno dei nostri specialisti direttamente da questo sito web.
                                            </Typography>
                                            <Button
                                                href="https://wa.me/3935663203?text=Vorrei%20prenotare%20una%20visita"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                color="inherit"
                                                variant="outlined"
                                                className={classes.homePrenotaSubitoButton}
                                                title="Prenota subito"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16" style={{marginRight: '8px'}}>
                                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                                                </svg>
                                                Prenota subito
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item sm={12} md={6} className={classes.homeContentCard}>
                                <Typography variant="h3" className={classes.homeContentTitle}>
                                    Elenco Servizi
                                </Typography>
                                <DepartmentsList listDepartments={listDepartments} />
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            </Box>
            <Box className={classes.mapWrapper}>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2933.1595331504545!2d14.010691415905898!3d42.6791628791668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133196a21fc78691%3A0x6fe3f18bdec761f0!2sStudio%20Medico%20Associato%20Ippocrates!5e0!3m2!1sit!2sit!4v1634312839863!5m2!1sit!2sit" width="100%" height="450" allowFullScreen="" loading="lazy" className={classes.iframe} title="Google Map"></iframe>
            </Box>
        </>
    );
}

export default HomeContent;